// Mirrors the text the partial renders server-side. The bubble classes carry colour only, so
// without this the announced state would stay on whichever step rendered first.
const STATE_TEXT = {
  'bubble-visited': 'Completed: ',
  'bubble-current': 'Current step: ',
  'bubble-unvisited': '',
};

/**
 * Updates progress-bubbles UI to the given 0-based step index.
 * Expects markup from Views/Shared/Partials/_ProgressBubbles.cshtml.
 */
export default function setProgressBubbleStep(stepIndex) {
  const root = document.querySelector('.progress-bubbles');
  if (!root) {
    return;
  }

  const steps = root.querySelectorAll('.progress-bubbles-step');
  const segments = root.querySelectorAll('.progress-bubbles-line-segment');
  if (!steps.length) {
    return;
  }

  const lastIndex = steps.length - 1;
  let current = stepIndex;
  if (current < 0) {
    current = 0;
  }
  if (current > lastIndex) {
    current = lastIndex;
  }

  const isComplete = current === lastIndex;

  steps.forEach((step, index) => {
    step.classList.remove('bubble-visited', 'bubble-current', 'bubble-unvisited');

    let state = 'bubble-unvisited';
    if (isComplete || index < current) {
      state = 'bubble-visited';
    } else if (index === current) {
      state = 'bubble-current';
    }
    step.classList.add(state);

    if (state === 'bubble-current') {
      step.setAttribute('aria-current', 'step');
    } else {
      step.removeAttribute('aria-current');
    }

    const stateLabel = step.querySelector('.progress-bubbles-state');
    if (stateLabel) {
      stateLabel.textContent = STATE_TEXT[state];
    }
  });

  segments.forEach((segment, index) => {
    segment.classList.toggle('is-visited', isComplete || index < current);
  });
}
